export const shouldCheckCreateTradeQuota = (
  isSignal: boolean,
  isFreeExchange: boolean
) => isSignal || !isFreeExchange;
